import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    DEBUG= "speedster",
    SCREENS = "screens",
    BIG_WIN_COUNT_UP = "big_win_count_up",
    BIG_WIN = "big_win",
    WIN_COUNT_UP = "win_count_up",
    AUDIO_VISUALS = "audio_visuals",
    NEAR_WIN = "near_win",
    WIN_PRESENTATIONS = "win_presentations",
    FOREGROUND_TOP = "foreground_top",
    SYMBOL_LANDING = "symbolLanding",
    FOREGROUND_DXW = "foreground_dxw",
    ENHANCER_REEL = "enhancerReel",
    ENHANCER_REEL_EFFECTS = "enhancerReelEffects",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    ENHANCER_SYMBOLS = "enhancer_symbols",
    NEARWIN_REEL = "nearwin_reel",
    REEL_AREA_DIMMER = "reel_area_dimmer",
    REEL_FRAME = "reel_frame",
    LINKED_SYMBOLS = "linked_symbols",
    HIGH_SYMBOLS = "high_symbols",

    WAYS = "ways",
    AUDIO_FD_LAYER = "audio_fd_layer",
    REEL_BACKGROUND = "reel_background",
    STICKY_SYMBOL = "sticky_symbol",
    BACKGROUND = "background"

}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    public name:string;

    constructor(name:string) {
        super();
        this.name = name;
    }

    // Note: these only check the direct children.
    public onResize():void {
        this.children.forEach((child:any) => {
            if(child.onResize) {
                child.onResize();
            }
        });
    }

    public onOrientationChanged():void {
        this.children.forEach((child:any) => {
            if(child.onOrientationChanged) {
                child.onOrientationChanged();
            }
        });
    }
}

export class TheRaveLayers {

    constructor() {
        for(const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(key), 0);
        }
    }

    public static getLayer(name:string):StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }

    public static getRePositionLayers():StageLayer[] | undefined[] {
        return [
            this.getLayer(Layers.REEL_FRAME)!,
            this.getLayer(Layers.HIGH_SYMBOLS)!,
            this.getLayer(Layers.REEL_BACKGROUND)!,
            this.getLayer(Layers.NEAR_WIN)!,
            this.getLayer(Layers.HIGH_SYMBOLS_WIN)!,
            this.getLayer(Layers.FOREGROUND_TOP)!,
            this.getLayer(Layers.ENHANCER_REEL)!,
            this.getLayer(Layers.ENHANCER_REEL_EFFECTS)!,
            this.getLayer(Layers.REEL_AREA_DIMMER)!,
            this.getLayer(Layers.ENHANCER_SYMBOLS)!,
        ];
    }
}